<template>
	<div class="menu-bar bg-light-green">
		<div v-if="loggedIn">
			<router-link v-for="(item, index) in items" :to="item.path" class="btn menu-action color-dark-grey">
				<i :class="'fa fa-' + item.icon + ' color-white'"></i><span>{{item.title}}</span>
			</router-link>
		</div>
  </div>
</template>
<script>
export default {
	name: 'appmenu',
	data () {
		return {
			items: [
				{title: 'Academy Mappings', icon: 'list', path: '/list'},
				{title: 'Academy Search', icon: 'search', path: '/search'},
				{title: 'New Mapping', icon: 'map', path: '/mapping'},
				{title: 'Troubleshooting', icon: 'address-card', path: '/troubleshooting'},
				{title: 'Activity Log', icon: 'book', path: '/log'}
			]
		}
	},
	computed: {
		loggedIn () {
			return this.$store.state.user.authenticated
		}
	}
}
</script>

<style scoped>
.menu-bar{
	padding: 0.5rem 0.75rem;
}
.toolbar-right{
	float:right;

}
</style>


// WEBPACK FOOTER //
// AppMenu.vue?4e1125a0